import { z } from 'zod';
export const SkillQueryParamSchema = z.object({
    limit: z.string().or(z.number().int().min(1).optional()).optional(),
    offset: z.string().or(z.number().int().min(0).optional()).optional(),
    search: z.string().optional(),
    type: z.enum(['other', 'digital']).optional()
});
//# sourceMappingURL=skillQueryParamSchema.js.map